import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import Title from 'components/Title';

import DepartmentCodesMapping from './DepartmentCodesMapping';
import TaskCodesMapping from './TaskCodesMapping';

interface ICostCodeMappingProps {
  showDepartmentCodes: boolean;
}

const CostCodeMapping: React.FC<ICostCodeMappingProps> = ({ showDepartmentCodes }) => {
  const { t } = useTranslation(['common', 'integrations']);

  return (
    <Stack gridGap={2}>
      <Title>{t('integrations:adp.adpWfnHomeCostsMapping')}</Title>
      {showDepartmentCodes ? <DepartmentCodesMapping /> : <TaskCodesMapping />}
    </Stack>
  );
};

export default CostCodeMapping;
